import {
  Award,
  HomeIcon,
  HeartHandshake,
  Sparkles,
  ShieldCheck,
  CalendarClock,
} from "lucide-react";

const POINTS = [
  {
    icon: Award,
    title: "Qualified Foot Health Practitioners",
    body: "Trained, insured and committed to safe, evidence-based treatment.",
  },
  {
    icon: HomeIcon,
    title: "Care in your own home",
    body: "No travel needed — we bring the clinic to your doorstep.",
  },
  {
    icon: HeartHandshake,
    title: "Compassionate & personal",
    body: "We take time to listen, assess, and tailor every treatment.",
  },
  {
    icon: Sparkles,
    title: "Hygienic & professional",
    body: "Sterile equipment, clinical standards, friendly approach.",
  },
  {
    icon: ShieldCheck,
    title: "Support for reduced mobility",
    body: "Specialist care for elderly patients and those recovering at home.",
  },
  {
    icon: CalendarClock,
    title: "Flexible appointments",
    body: "Convenient home visits that fit around your schedule.",
  },
];

export default function WhyChoose() {
  return (
    <section data-testid="why-section" className="lfc-section relative overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#4A2D7A] to-transparent" />
      <div className="absolute -top-20 right-1/4 w-96 h-96 rounded-full bg-[#2BB8B4]/8 blur-[120px] pointer-events-none" />

      <div className="lfc-container relative">
        <div className="max-w-3xl">
          <div className="lfc-eyebrow mb-4">Why choose us</div>
          <h2 className="lfc-h2">A caring approach to long-term foot health.</h2>
          <p className="mt-5 text-lg text-[#C2B4E6] leading-relaxed">
            Healthy feet are essential for mobility, independence and quality of life.
            We focus on prevention, comfort and dignity — because every patient deserves expert care without the hassle of travel.
          </p>
          <div className="lfc-divider-leaf mt-7" />
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {POINTS.map((p, i) => (
            <div
              key={p.title}
              data-testid={`why-card-${i}`}
              className="lfc-card p-7"
            >
              <div className="grid place-items-center w-12 h-12 rounded-2xl bg-[#2BB8B4] text-[#0E0524] lfc-glow-teal">
                <p.icon className="w-5 h-5" strokeWidth={1.8} />
              </div>
              <h3
                className="mt-5 text-xl font-semibold text-white"
                style={{ fontFamily: "Outfit" }}
              >
                {p.title}
              </h3>
              <p className="mt-2.5 text-[15.5px] text-[#C2B4E6] leading-relaxed">
                {p.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
